import { useEffect } from 'react'
import * as Sentry from '@sentry/tanstackstart-react'
import { createFileRoute, type ErrorComponentProps } from '@tanstack/react-router'
import { SchoolNewRuleClient } from '../components/SchoolNewRuleClient'
import { prefetchSchoolPolicies, prefetchSchoolGroups } from '../lib/route-prefetch'

function SchoolNewRuleError({ error }: ErrorComponentProps) {
  useEffect(() => { Sentry.captureException(error) }, [error])
  return (
    <div className="p-8 text-center text-gray-600">
      Failed to load rule creator.{' '}
      <button onClick={() => window.location.reload()} className="text-brand underline">
        Retry
      </button>
    </div>
  )
}

export const Route = createFileRoute('/school/$schoolId/rules/new')({
  head: () => ({ meta: [{ title: 'New School Rule | Unbreakable' }] }),
  beforeLoad: ({ context, params }) => {
    prefetchSchoolPolicies(context.queryClient, params.schoolId)
    prefetchSchoolGroups(context.queryClient, params.schoolId)
  },
  errorComponent: SchoolNewRuleError,
  component: SchoolNewRulePage,
})

function SchoolNewRulePage() {
  return <SchoolNewRuleClient />
}
